import Vue from 'vue'
import Vuex from 'vuex'
import {
  clearAuth,
  getUser,
  isLoggedIn,
  saveAuth
} from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: getUser(),
    loggedIn: isLoggedIn(),
    loginModalVisible: false,
    loginRedirect: '/',
    paymentModal: {
      visible: false,
      qrUrl: '',
      orderNo: '',
      orderStatus: null,
      payAmount: null
    }
  },
  mutations: {
    SET_AUTH(state, { user }) {
      state.user = user
      state.loggedIn = true
    },
    CLEAR_AUTH(state) {
      state.user = null
      state.loggedIn = false
    },
    SHOW_LOGIN(state, redirect) {
      state.loginModalVisible = true
      state.loginRedirect = redirect || '/'
    },
    HIDE_LOGIN(state) {
      state.loginModalVisible = false
    },
    SHOW_PAYMENT(state, payload) {
      state.paymentModal = {
        visible: true,
        qrUrl: payload.qrUrl,
        orderNo: payload.orderNo || '',
        orderStatus: payload.orderStatus,
        payAmount: payload.payAmount != null ? payload.payAmount : null
      }
    },
    HIDE_PAYMENT(state) {
      state.paymentModal = {
        visible: false,
        qrUrl: '',
        orderNo: '',
        orderStatus: null,
        payAmount: null
      }
    }
  },
  actions: {
    loginSuccess({ commit }, { token, user, redirect, router }) {
      saveAuth(token, user)
      commit('SET_AUTH', { user })
      commit('HIDE_LOGIN')

      const inviterId = localStorage.getItem('saas_inviter_id')
      if (inviterId) {
        import('@/api/auth').then(({ bindInviter }) => {
          bindInviter(inviterId).catch(() => {})
        })
      }

      if (redirect && router) {
        router.push(redirect).catch(() => {})
      }
    },
    logout({ commit, rootState }, router) {
      clearAuth()
      commit('CLEAR_AUTH')
      if (router && router.currentRoute.meta && router.currentRoute.meta.requiresAuth) {
        router.push('/').catch(() => {})
      }
    }
  }
})
